<template>
  <zen-one 
    :showuserinfo="false" 
    :crumbs="crumbs"
    title="Sistem Hasil Bersepadu Kedah (iHasil)"
  >
    <z-page title="Senarai Penyesuaian">
            <w-card bg-color="" class="">
                <w-flex justify-center align-center>
                    <div class="xs4">
                        <h5 class="fw-semibold m0">Nama Fail :</h5>
                        <div class="fw-normal my1 fs-1">{{form.nama_fail}}
                        </div>
                    </div>

                    <div class="xs4">
                        <h5 class="fw-semibold m0">Bil. Rekod:</h5>
                        <div class="fw-normal my1 fs-1"><template v-if="form.detail">{{ form.detail.jumlah }}</template></div>
                    </div>
                </w-flex>

                <w-flex justify-center align-center>
                    <div class="xs4">
                        <h5 class="fw-semibold m0">Tarikh Fail:</h5>
                        <div class="fw-normal my1 fs-1">{{$zutil.dateformat(form.tarikh_fail)}}</div>
                    </div>

                    <div class="xs4">
                        <h5 class="fw-semibold m0">Bil. Rekod Sepadan:</h5>
                        <div class="fw-normal my1 fs-1"><template v-if="form.detail">{{ form.detail.jumlah_sesuai }}</template></div>
                    </div>
                </w-flex>

                <w-flex justify-center align-center>
                    <div class="xs4">
                        <h5 class="fw-semibold m0">Tarikh Proses:</h5>
                        <div class="fw-normal my1 fs-1">{{$zutil.dateformat(form.updated_at)}}</div>
                    </div>

                    <div class="xs4">
                        <h5 class="fw-semibold m0">Bil. Rekod Tidak Sepadan:</h5>
                        <div class="fw-normal my1 fs-1"><template v-if="form.detail">{{ form.detail.jumlah_ga_sesuai }}</template></div>
                    </div>
                </w-flex>

                <w-flex justify-center align-center>
                    <div class="xs4">
                       <!--  <h5 class="fw-semibold m0">Diproses Oleh:</h5>
                        <div class="fw-normal my1 fs-1">{{form.user_id}}</div> -->
                    </div>

                    <div class="xs4">
                        <h5 class="fw-semibold m0">Amaun Bank(RM):</h5>
                        <div class="fw-normal my1 fs-1">
                        <template v-if="form.detail">{{$zutil.currency(form.detail.amaun_fail)}}</template>
                        </div>
                    </div>
                </w-flex>

                <w-flex justify-center align-center>
                    <div class="xs4">
                        <h5 class="fw-semibold m0">Status:</h5>
                        <div class="fw-normal my1 fs-1">{{form.status}}</div>
                    </div>

                    <div class="xs4">
                        <h5 class="fw-semibold m0">Amaun Resit(RM):</h5>
                        <div class="fw-normal my1 fs-1">
                           <template v-if="form.detail"> {{ $zutil.currency(form.detail.amaun_resit) }} </template></div>
                    </div>
                </w-flex>
            </w-card>

            <w-tabs :items="tabs" :no-slider="false" active-class="primary">
              <template #item-content.1>
                <div class="w-card__content content-hardcode" style="overflow-x:auto;">
                  <table class="table-dashboard" width="100%">
                      <thead>
                          <tr class="center">
                              <td>Bil</td>
                              <!-- <td>TID</td> -->
                              <td>Tarikh</td>
                              <td>No. Rujukan</td>
                              <td>Cara Bayar</td>
                              <td>Amaun</td>
                          </tr>
                      </thead>
                      <tbody>
                        <template v-if='form.detail'>
                          <tr v-for="(dt, index) in form.detail.butiran">
                            <td>{{ index + 1 }}</td>
                            <!-- <td>{{dt.tid}}</td> -->
                            <td>{{$zutil.dateformat(dt.transaction_date)}}</td>
                            <td>{{dt.auth_code}}</td>
                            <td>{{dt.tran_type}}</td>
                            <td>{{$zutil.currency(dt.gross_amount)}}</td>
                          </tr>
                        </template>
                        </tbody>
                      </table>
                    </div>
              </template>

              <template #item-content.2>
                <div class="w-card__content content-hardcode" style="overflow-x:auto;">
                  <table class="table-dashboard" width="100%">
                      <thead>
                          <tr class="center">
                              <td>Bil</td>
                              <!-- <td>TID</td> -->
                              <td>Tarikh</td>
                              <td>No. Rujukan</td>
                              <td>Cara Bayar</td>
                              <td>No Resit</td>
                              <td>Tarikh Resit</td>
                              <td>No Dokumen</td>
                              <td>Amaun</td>
                          </tr>
                      </thead>
                      <tbody>
                        <template v-if='form.detail'>
                          <tr v-for="(dt, index) in form.detail.sesuai">
                            <td>{{ index + 1 }}</td>
                            <!-- <td>{{dt.tid}}</td> -->
                            <td>{{$zutil.dateformat(dt.transaction_date)}}</td>
                            <td>{{dt.auth_code}}</td>
                            <td>{{dt.tran_type}}</td>
                            <td><inertia-link :href='$route("kutipan.resit.show",dt.resit_id)' v-if="dt.resit">{{dt.resit.no_resit}}</inertia-link></td>
                            <td><template v-if="dt.resit">{{$zutil.dateformat(dt.resit.tarikh_bayar)}}</template> </td>
                            <td><template v-if="dt.resit">{{dt.resit.no_dokumen}}</template> </td>
                            <td>{{$zutil.currency(dt.gross_amount)}}</td>
                          </tr>
                        </template>
                        </tbody>
                      </table>
                    </div>
              </template>

              <template #item-content.3>
                <div class="w-card__content content-hardcode" style="overflow-x:auto;">
                  <table class="table-dashboard" width="100%">
                      <thead>
                          <tr class="center">
                              <td>Bil</td>
                              <!-- <td>TID</td> -->
                              <td>Tarikh</td>
                              <td>No. Rujukan</td>
                              <td>Cara Bayar</td>
                              <td>No Resit</td>
                              <td>Tarikh Resit</td>
                              <td>No Dokumen</td>
                              <td>Amaun</td>
                          </tr>
                      </thead>
                      <tbody>
                        <template v-if='form.detail'>
                          <tr v-for="(dt, index) in form.detail.ga_sesuai">
                            <td>{{ index + 1 }}</td>
                            <!-- <td>{{dt.tid}}</td> -->
                            <td>{{$zutil.dateformat(dt.transaction_date)}}</td>
                            <td>{{dt.auth_code}}</td>
                            <td>{{dt.tran_type}}</td>
                            <td><inertia-link :href='$route("kutipan.resit.show",dt.resit_id)' v-if="dt.resit">{{dt.resit.no_resit}}</inertia-link></td>
                            <td><template v-if="dt.resit">{{$zutil.dateformat(dt.resit.tarikh_bayar)}}</template> </td>
                            <td><template v-if="dt.resit">{{dt.resit.no_dokumen}}</template> </td>
                            <td>{{$zutil.currency(dt.gross_amount)}}</td>
                          </tr>
                        </template>
                        </tbody>
                      </table>
                    </div>
                
              </template>
              <template #item-content.4>
                <div class="w-card__content content-hardcode" style="overflow-x:auto;">
                  <table class="table-dashboard" width="100%">
                      <thead>
                          <tr class="center">
                              <td>Bil</td>
                              <td>TID</td>
                              <td>Tarikh</td>
                              <td>No. Rujukan</td>
                              <td>Cara Bayar</td>
                              <td>Amaun</td>
                          </tr>
                      </thead>
                      <tbody>
                        <template v-if='form.detail'>
                          <tr v-for="(dt, index) in form.detail.ga_ada_resit">
                            <td>{{ index + 1 }}</td>
                            <td>{{dt.tid}}</td>
                            <td>{{$zutil.dateformat(dt.transaction_date)}}</td>
                            <td>{{dt.auth_code}}</td>
                            <td>{{dt.tran_type}}</td>
                            <td>{{$zutil.currency(dt.gross_amount)}}</td>
                          </tr>
                        </template>
                        </tbody>
                      </table>
                    </div>
                
              </template>
            </w-tabs>
              <w-flex class="mt3" wrap align-center justify-end>
                  <w-button
                      class="my1"
                      bg-color="warning"
                      dark
                      @click="back()"
                      >Kembali</w-button
                  >
              </w-flex>
        </z-page>
  </zen-one>
</template>

<script>

import ZResource from '@/Modules/z-resource-service'


export default {
  extends: ZResource,
  components: {
    
  },
  props: {
    id: [Array, Object, String],
  },
  data() {
    return {

  
      resourceurl: this.service_penyata+'fail_mdr',
      reload: true,
      
      tabs: [
          { title: "Fail", content: "" },
          { title: "Sepadan", content: "" },
          { title: "Tidak Sepadan", content: "" },
          { title: "Tiada Resit", content: "" },
      ],
      crumbs: [
        { label: 'iHasil', route: '/' },
        { label: 'Penyesuaian', route: '/fail_mdr' },
        { label: 'Papar', route: '/fail_mdr/'+this.id },
      ],
    }
  },
  methods: {
    back() {
      window.history.back();
    },
  
  },
  watch: {

  },
  mounted() {
    
      
  },
    
}
</script>